// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseHref: '/',
  // baseURL: 'http://192.168.1.14:8070/rest/s1',
  // baseURL: 'https://doremi.iamsoftware.com.vn/erp/rest/s1',
  // documentURL: 'https://doremi.iamsoftware.com.vn/erp/apps/MagErp',
  // contentURL: 'https://doremi.iamsoftware.com.vn/erp/PublicContent',
  baseURL: 'https://doremi2.iamsoftware.com.vn/erp/rest/s1',
  // baseURL: 'http://127.0.0.1/rest/s1',
  // documentURL: 'http://192.168.1.14:8070/apps/MagErp',
  documentURL: 'https://doremi2.iamsoftware.com.vn/apps/MagErp',
  contentURL: 'https://doremi2.iamsoftware.com.vn/PublicContent'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
